import WAValidator from "multicoin-address-validator";

const validateNetwork = (network: string, address: string) => {
  const bitcoinRegex =
    /^(1[a-km-zA-HJ-NP-Z1-9]{25,33}|3[a-km-zA-HJ-NP-Z1-9]{24,34}|bc1[a-zA-HJ-NP-Z0-9]{39,59})$/;
  const ethereumRegex = /^0x[a-fA-F0-9]+$/;
  const binanceRegex = /^0x[a-fA-F0-9]+$/;
  const tronRegex = /^T[1-9A-HJ-NP-Za-km-z]+$/;
  switch (network.toLowerCase()) {
    case "btc":
      return bitcoinRegex.test(address);
    case "eth":
      return ethereumRegex.test(address);
    case "bsc":
      return binanceRegex.test(address);
    case "trx":
      return tronRegex.test(address);
    case "matic":
    case "pol":
    case "polygon":
      return ethereumRegex.test(address);
    default: {
      const valid: boolean = WAValidator.validate(
        address,
        network === "BSC" ? "BNB" : network
      );
      return valid;
    }
  }
};
export const validateWalletAddress = (
  address: string,
  coin: string,
  network: string
) => {
  const validNetwork = validateNetwork(network, address);
  return validNetwork;
};